class ToggleableBox extends HTMLElement
{
  constructor ()
  {
    super();

    this.targetElement = this.querySelector('.toggleable-box');
    this.init();
  }

  init ()
  {
    this.querySelector('.toggleable-box-head').addEventListener('click', e => {
      e.preventDefault();

      this.toggle();
    });
  }

  toggle ()
  {
    const body = this.querySelector('.toggleable-box-body');
    const animationTime = 250;

    let start, previousTimeStamp, height;
    let isDone = false, isIncrease = true;

    if (this.targetElement.classList.contains('open')) {
      height = body.offsetHeight;
      body.style.height = '0px';
      body.style.overflow = 'hidden';
      isIncrease = false;
    } else {
      this.targetElement.classList.add('open');
      body.style.height = 'auto';
      height = body.offsetHeight;
      body.style.height = '0px';
      body.style.overflow = 'hidden';
    }

    // Animate

    const done = () => {
      body.style.height = '';
      body.style.overflow = '';

      if (!isIncrease) {
        this.targetElement.classList.remove('open');
      }
    }

    const step = (timeStamp) => {
      if (start === undefined) {
        start = timeStamp;
      }

      const elapsed = timeStamp - start;

      if (previousTimeStamp !== timeStamp) {
        let count = isIncrease
          ? (elapsed / animationTime) * height
          : (1 - (elapsed / animationTime)) * height;

        if (isIncrease && count >= height) {
          count = height;
          isDone = true;
        } else if (!isIncrease && count <= 0) {
          count = 0;
          isDone = true;
        }

        body.style.height = `${count}px`;
      }

      if (elapsed < animationTime) {
        previousTimeStamp = timeStamp;

        if (!isDone) {
          window.requestAnimationFrame(step);
        } else {
          done();
        }
      } else {
        done();
      }
    }

    window.requestAnimationFrame(step);
  }
}

if (!customElements.get('toggleable-box')) {
  customElements.define('toggleable-box', ToggleableBox);
}